define("settings/components/integrations/mavely/profile", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    <td>
      <span>
        {{@mavelyProfile.email}}
      </span>
    </td>
    <td>
      {{#if @mavelyProfile.authenticated}}
        <span class="u--text--light">
          {{t "shared_words.connected"}}
        </span>
      {{else}}
        <span class="u--text--warning">
          {{t "shared_words.expired"}}
          <span {{on "click" this.toggleRefreshInfoModal}}>
            {{svg-jar "info" class="o--icon"}}
          </span>
        </span>
      {{/if}}
    </td>
    <td>
      {{#unless @mavelyProfile.authenticated}}
        <Shared::Ui::Button
          @class={{concat-classes "qa--mavelyProfile_refresh_btn" "u--text--danger"}}
          @promise={{task @refresh @mavelyProfile}}
          @text={{t "shared_words.refresh"}}
          @variant="outline"
        />
      {{/unless}}
  
      <Shared::Ui::Button
        @promise={{this.disconnect}}
        @text={{t "shared_words.remove"}}
        @variant="unstyled"
        class="o--btn o--btn--mute qa--mavelyProfile_remove_btn"
        data-test-id="profile-item-remove"
      />
    </td>
  </tr>
  {{#if this.showRefreshInfoModal}}
    {{! @glint-expect-error: Shared::Modal }}
    <Shared::Modal @close={{this.toggleRefreshInfoModal}} as |modal|>
      <modal.card @portrait={{true}}>
        <modal.card-header @title={{t "account.mavely.refresh_title"}} />
        <modal.card-body>
          <p class="u--text">
            {{t "account.mavely.refresh_required" account=@mavelyProfile.email}}
          </p>
        </modal.card-body>
        <modal.card-footer>
          <Shared::Ui::Button
            @additional="block"
            @onClick={{this.toggleRefreshInfoModal}}
            @text={{t "shared_words.close"}}
            @variant="outline"
          />
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "TLrWDVgx",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[30,1,[\"email\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,1,[\"authenticated\"]],[[[1,\"      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.connected\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[14,0,\"u--text--warning\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.expired\"],null]],[1,\"\\n        \"],[11,1],[4,[38,2],[\"click\",[30,0,[\"toggleRefreshInfoModal\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[51,[30,1,[\"authenticated\"]]],[[[1,\"      \"],[8,[39,5],null,[[\"@class\",\"@promise\",\"@text\",\"@variant\"],[[28,[37,6],[\"qa--mavelyProfile_refresh_btn\",\"u--text--danger\"],null],[28,[37,7],[[30,2],[30,1]],null],[28,[37,1],[\"shared_words.refresh\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,5],[[24,0,\"o--btn o--btn--mute qa--mavelyProfile_remove_btn\"],[24,\"data-test-id\",\"profile-item-remove\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"disconnect\"]],[28,[37,1],[\"shared_words.remove\"],null],\"unstyled\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"showRefreshInfoModal\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@close\"],[[30,0,[\"toggleRefreshInfoModal\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"account.mavely.refresh_title\"],null]]],null],[1,\"\\n      \"],[8,[30,3,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"u--text\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.mavely.refresh_required\"],[[\"account\"],[[30,1,[\"email\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,5],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"toggleRefreshInfoModal\"]],[28,[37,1],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[]],null]],[\"@mavelyProfile\",\"@refresh\",\"modal\"],false,[\"if\",\"t\",\"on\",\"svg-jar\",\"unless\",\"shared/ui/button\",\"concat-classes\",\"task\",\"shared/modal\"]]",
    "moduleName": "settings/components/integrations/mavely/profile.hbs",
    "isStrictMode": false
  });
  let MavelyProfileComponent = _exports.default = (_class = class MavelyProfileComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "mavelyAuth", _descriptor, this);
      _initializerDefineProperty(this, "showRefreshInfoModal", _descriptor2, this);
      _defineProperty(this, "disconnect", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.mavelyAuth.disconnect.perform({
            area: 'global-settings',
            group: this.args.group,
            profile: this.args.mavelyProfile
          });
        }
      }), null, "disconnect", null));
    }
    toggleRefreshInfoModal() {
      this.showRefreshInfoModal = !this.showRefreshInfoModal;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mavelyAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showRefreshInfoModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleRefreshInfoModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleRefreshInfoModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyProfileComponent);
});